module.exports = __webpack_public_path__ + "static/media/finger.ee071e1e.svg";